// InstallButton.js
import React, {useEffect, useState} from 'react';
import {isMobile} from "../App/utils";
import { Button } from "@mui/material";
import {urlBase64ToUint8Array} from "../utils";
import {createPushSubscription} from "../API/KB/KBAPI";

export function subscribeUserToPush() {
    navigator.serviceWorker.ready.then(function(registration) {
        const applicationServerPublicKey = 'BHds-00cqVn80fcViBrN8KnujyE84LpC4X7jM5HGp-qlEHs0pKtLVM15ncj07OLfpeSYzNYROGjqNo4LE0NY1d0';
        const applicationServerKey = urlBase64ToUint8Array(applicationServerPublicKey);
        registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: applicationServerKey
        }).then(function(subscription) {
            // logToScreen(JSON.stringify(subscription))
            createPushSubscription(subscription)
        }).catch(function(err) {
            console.log('Failed to subscribe the user: ', err);
        });
    });
}

export const handleSubscribePushNotifications = ({setNotificationsPermissionStatus}) => {
    window?.Notification?.requestPermission().then(function (permission) {
        if (permission === "granted") {
            setNotificationsPermissionStatus(permission);
            // After permission is granted, subscribe the user to push notifications
            subscribeUserToPush();
        }
    });
}

export const EnableNotificationsButton = ({ notificationsPermissionStatus, setNotificationsPermissionStatus, text }) => {
    const handleClick = () => {
        handleSubscribePushNotifications({notificationsPermissionStatus, setNotificationsPermissionStatus})
    };

    const calculateFontSize = (title) => {
        let fontSize = 22 * 0.875 * (22 / title.length);
        fontSize = Math.max(8, fontSize);
        fontSize = Math.min(12, fontSize);
        return fontSize;
    };

    const title = `Enable Notifications`;
    const fontSize = calculateFontSize(title);

    if (["granted", "denied", "notsupported", false].includes(notificationsPermissionStatus)) return null;

    return text
        ? <div onClick={handleClick}>{text}</div>
        : (
        <>
            <div style={{
                position: 'absolute',
                top: isMobile ? '74px' : '74px',
                left: isMobile ? '50%' : '90%',
                transform: 'translateX(-50%)',
                zIndex: isMobile ? 200 : undefined
            }}>
                {(
                    <Button
                        variant="contained"
                        color="secondary"
                        onClick={handleClick}
                        style={{
                            padding: '4px 16px',
                            fontSize: `${fontSize}px`,
                            textTransform: 'none',
                            maxWidth: '240px',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        {title}
                    </Button>
                )}
            </div>
            {/*<Snackbar*/}
            {/*    open={snackbarOpen}*/}
            {/*    autoHideDuration={30000}*/}
            {/*    onClose={() => setSnackbarOpen(false)}*/}
            {/*    message="The app has been installed. If you do not see the app icon on your home screen, please restart your device."*/}
            {/*    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}*/}
            {/*/>*/}
        </>
    );
};